<div class="user-form">
    <div class="back">
        <button type="button" routerLink="/admin/users">
            <span class="icon-anchor-top"></span>
            <span>Back to User Management</span>
        </button>
    </div>

    <h3 class="title">{{ title() }}</h3>

    <form [formGroup]="form">
        <div>
            <mat-form-field class="dropdown">
                <mat-label>User type</mat-label>
                <mat-select formControlName="userType">
                    @for (option of userTypeOptions; track option.value) {
                        <mat-option [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if (showSiriusXmFields()) {
                <p class="caption-4">
                    SiriusXM users sign in with Okta. Request the required Okta
                    role in ServiceNow before adding them.
                </p>
            }
        </div>

        @if (showSiriusXmFields()) {
            <div>
                <tools-input-outline
                    label="SIRIUSXM EMAIL"
                    placeholder="Enter SiriusXM Email"
                    formControlName="email"
                ></tools-input-outline>
                @if (emailError()) {
                    <span class="error">Enter a valid email address.</span>
                }
            </div>
        }

        @if (showExternalFields()) {
            <div>
                <tools-input-outline
                    label="FIRST NAME"
                    placeholder="Enter First Name"
                    formControlName="firstName"
                ></tools-input-outline>
            </div>

            <div>
                <tools-input-outline
                    label="LAST NAME"
                    placeholder="Enter Last Name"
                    formControlName="lastName"
                ></tools-input-outline>
            </div>

            <div>
                <tools-input-outline
                    label="EMAIL"
                    placeholder="Enter Email"
                    formControlName="email"
                ></tools-input-outline>
                @if (emailError()) {
                    <span class="error">Enter a valid email address.</span>
                }
            </div>
        }

        @if (showRoleField()) {
            <div>
                <mat-form-field class="dropdown">
                    <mat-label>Role</mat-label>
                    <mat-select formControlName="role">
                        @for (option of roleOptions(); track option.value) {
                            <mat-option [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        }

        @if (showTenantAccess()) {
            <div>
                <p class="callout-1">Tenant Access</p>
                <p class="caption-4">
                    Choose the shows or channels this user can access.
                </p>
                <app-tenant-access
                    formControlName="tenantIds"
                ></app-tenant-access>
            </div>
        }
    </form>

    <div class="action-bar">
        @if (canDelete()) {
            <tools-button
                class="delete"
                [variant]="buttonVariant.OUTLINE"
                [isDisabled]="isSubmitting()"
                (onClick)="deleteRequested.emit()"
            >
                Delete User
            </tools-button>
        }
        <tools-button [isDisabled]="isSubmitDisabled()" (onClick)="onSubmit()">
            {{ primaryLabel() }}
        </tools-button>
    </div>
</div>
